import TC_Wrapper from "react-tag-commander";
const tc_wrapper = TC_Wrapper.getInstance();

const disableTransition = process.env.REACT_APP_DISABLE_TRANSITION === "true";
export const pageName = {};
export const wrapper = disableTransition
  ? {
      getInstance: (...args: any) => console.log({ getInstance: args }),
      setTcVar: (...args: any) => console.log({ setTcVar: args }),
      setTcVars: (...args: any) => console.log({ setTcVars: args }),
      triggerEvent: (...args: any) => console.log({ triggerEvent: args }),
    }
  : tc_wrapper;
